<script lang="ts">
    import type { Setting, CustomSetting } from "..";

    import { Components } from ".";
    import Label from "./Label.svelte";
    import { onMount } from "svelte";
    import { linkHandling } from "../link";

    export let setting: Setting;

    const {
        id,
        type
    } = setting;

    function reset() {
        setting.value = setting.default;
    }

    if (setting.type === "custom") {
        onMount(() => {
            linkHandling.settingsCallbacks[id] = () => (setting as CustomSetting<any>).component?.focus?.();
            return () => linkHandling.settingsCallbacks[id] = undefined;
        });
    }

    const component = setting.type === "custom" ? setting.component : Components[type as "boolean"] as any;
</script>

<!----------------------------------------------------------------------------->

{#if setting.type === "custom"}
    <svelte:component this={component} bind:setting={setting} />
{:else}
    <Label {setting}>
        <svelte:component this={component} bind:setting={setting} />
        <button slot="reset" class="reset" on:click|preventDefault={reset} on:pointerdown|preventDefault on:pointerup|preventDefault disabled={setting.value === setting.default}>↺</button>
    </Label>
{/if}

<!----------------------------------------------------------------------------->

<style>
    .reset {
        all: unset;
        font-size: 1.25em;
        width: 1em;
        height: 1.25em;
        line-height: 1;
        padding-bottom: 0.25em;
        user-select: none;

        &:hover {
            color: var(--tacc);
        }

        &:disabled {
            color: var(--t400);
        }
    }
</style>
